import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { Globals } from '../../globals';
import { TableModule } from 'primeng/table';
import { SelectItem } from 'primeng/api';
import { CALPADSService } from '../../Services/CALPADSService';
import { saveAs } from '../../../../node_modules/file-saver/src/FileSaver';

import { ICALPADSTables } from '../../Models/ICALPADSTables';
import { ICALPADSTable14 } from '../../Models/ICALPADSTable14';
import { ICALPADSTable15 } from '../../Models/ICALPADSTable15';
import { ICALPADSTable17 } from '../../Models/ICALPADSTable17';
import { ICALPADSTable22 } from '../../Models/ICALPADSTable22';
import { ICALPADSTable23 } from '../../Models/ICALPADSTable23';
import { ICALPADSTable24 } from '../../Models/ICALPADSTable24';
import { ICALPADSTable25 } from '../../Models/ICALPADSTable25';
import { ICALPADSCallBackCode } from '../../Models/ICALPADSCallBackCode';
import { ICALPADSUploadFile } from '../../Models/ICALPADSUploadFile';
import { ICALPADSToken } from '../../Models/ICALPADSToken';
import { CALPADSFileTypeEnum } from '../../Models/Enums/CALPADSFileTypeEnum';
import { ICALPADSErrorDetailSPED } from '../../Models/ICALPADSErrorDetailSPED';
import { ICALPADSErrorDetailSSRV } from '../../Models/ICALPADSErrorDetailSSRV';
import { ICALPADSStatusDetail, ICALPADSErrorSummary } from '../../Models/ICALPADSStatusDetail';
import { ICALPADSUploadedFileDetail } from '../../Models/ICALPADSUploadedFileDetail';
import { ICALPADSUploadFileResponse } from '../../Models/ICALPADSUploadFileResponse';
import { IAppsettingsConfig } from 'src/app/Models/IAppsettingsConfig';

@Component({
  selector: 'CALPADS',
  templateUrl: './CALPADS.component.html',
})
export class CALPADSComponent {

  private _baseUrl: string;
  priorTableState: boolean;
  validToken: boolean;
  tokenInserted: boolean;
  CodeChallenge: string;
  calpadsToken: string;
  table14Count: number = 0;
  table15Count: number = 0;
  table17Count: number = 0;
  table22Count: number = 0;
  table23Count: number = 0;
  table24Count: number = 0;
  table25Count: number = 0;
  table14: ICALPADSTable14[];
  table15: ICALPADSTable15[];
  table17: ICALPADSTable17[];
  table22: ICALPADSTable22[];
  table23: ICALPADSTable23[];
  table24: ICALPADSTable24[];
  table25: ICALPADSTable25[];
  table14CSV: string;
  table15CSV: string;
  table17CSV: string;
  table22CSV: string;
  table23CSV: string;
  table24CSV: string;
  table25CSV: string;
  table14FileName: string;
  table15FileName: string;
  table17FileName: string;
  table22FileName: string;
  table23FileName: string;
  table24FileName: string;
  table25FileName: string;
  calpadsTablesDB: any = [];
 
  uploadedFiles: any[] = [];

  spedErrors: ICALPADSErrorDetailSPED[];
  ssrvErrors: ICALPADSErrorDetailSSRV[];
  uploadedFileDetails: ICALPADSUploadedFileDetail[];
  uploadFileResponse: ICALPADSUploadFileResponse;
  status: ICALPADSStatusDetail;
  CALPADSTokenResponse: ICALPADSToken;
  statusDetails: ICALPADSErrorSummary[];

  showSpinner: boolean = false;
  showTable14: boolean = false;
  showTable15: boolean = false;
  showTable17: boolean = false;
  showErrorsSPED: boolean = false;
  showErrorsSSRV: boolean = false;
  showUploadedFileDetails: boolean = false;
  showFileUploadSuccess: boolean = false;
  showStatusDetails: boolean = false;

  tablesReturned: boolean = false;
  isCalpadsAuthenticated: boolean = true;
  DistrictCode: number = 1910199;
  ErrorJobId: number;
  StatusJobId: number;

  uploadTimeframeOptions: SelectItem[];
  fileTypeOptions: SelectItem[];
  fileStatusOptions: SelectItem[];

  selectedUploadTimeframeOption: string = 'Month';
  selectedFileTypeOption: string = 'SPED';
  selectedFileStatusOption: string = 'All';

  constructor(
    private httpClient: HttpClientModule,
    private globals: Globals,
    private route: ActivatedRoute,
    @Inject('BASE_URL') baseUrl: string,
    private calpadsService: CALPADSService) {
    this._baseUrl = baseUrl;

    this.uploadTimeframeOptions = [
      { label: 'Day', value: 'Day' },
      { label: 'Week', value: 'Week' },
      { label: 'Month', value: 'Month' },
      { label: 'Three Months', value: 'ThreeMonths' }
    ];

    this.fileTypeOptions = [
      { label: 'SPED', value: 'SPED' },
      { label: 'SSRV', value: 'SSRV' }
    ];

    this.fileStatusOptions = [
      { label: 'All', value: null },
      { label: 'Processing', value: 'Processing' },
      { label: 'In Queue', value: 'InQueue' },
      { label: 'In Process', value: 'InProcess' },
      { label: 'Ready for Review', value: 'ReadyForReview' },
      { label: 'In Review', value: 'InReview' },
      { label: 'Posted', value: 'Posted' },
      { label: 'Cancelled', value: 'Cancelled' },
      { label: 'Upload Failed', value: 'UploadFailed' },
      { label: 'Post Requested', value: 'PostRequested' },
      { label: 'Post Failed', value: 'PostFailed' },
      { label: 'Excluded', value: 'Excluded' },
      { label: 'Partial Post', value: 'PartialPost' },
      { label: 'Revision in Progress', value: 'RevisionInProgress' },
      { label: 'Revision Complete', value: 'RevisionComplete' }
    ];

  }

  ngOnInit(): void {
    this.validToken = false;
    this.tokenInserted = false;
    this.GetCALPADSToken();    
  }

  GetCALPADSToken(): void {
    var calpadsCodes = {} as ICALPADSCallBackCode;
    this.route.queryParams.subscribe(params => {
      calpadsCodes.code = params['code'];
      calpadsCodes.codeVerifier = sessionStorage.getItem('CodeVerifier');
    });
    if (calpadsCodes.code != null) {
      this.calpadsService.CALPADSToken(calpadsCodes).subscribe((res: ICALPADSToken) => {
        this.calpadsToken = res.access_token;
        this.CALPADSTokenResponse = res;
        if (res.access_token != null) {
          this.validToken = true;
          this.PostCALPADSToken()
        }
      },
        err => {
          console.error(err);
        }
      );
    }
  }

  PostCALPADSToken(): void {
    this.calpadsService.insertUpdateCALPADSToken(this.CALPADSTokenResponse).subscribe((response) => {
      this.tokenInserted = true;
      //console.info(response);
    },
      err => {
        console.error(err);
      }
    );
  }

  GetCALPADSDataTables() {
    this.showSpinner = true;
    this.tablesReturned = false;
    this.HideAllTables();
    this.calpadsService.getCALPADSDataTablesUat()
    //this.calpadsService.getCALPADSDataTables(this._baseUrl + 'api/CALPADS/GetCALPADSDataTables')
      .subscribe((res: ICALPADSTables) => {
        this.calpadsTablesDB = res as ICALPADSTables;
        if (res.calpadsTable14Array) {
          this.table14 = res.calpadsTable14Array;
          this.table15 = res.calpadsTable15Array;
          this.table17 = res.calpadsTable17Array;

          this.table14Count = res.calpadsTable14Array.length;
          this.table15Count = res.calpadsTable15Array.length;
          this.table17Count = res.calpadsTable17Array.length;

          this.table14CSV = this.calpadsTablesDB.calpadsTable14CSV;
          this.table15CSV = this.calpadsTablesDB.calpadsTable15CSV;
          this.table17CSV = this.calpadsTablesDB.calpadsTable17CSV;

          this.table14FileName = this.calpadsTablesDB.calpadsTable14FileName;
          this.table15FileName = this.calpadsTablesDB.calpadsTable15FileName;
          this.table17FileName = this.calpadsTablesDB.calpadsTable17FileName;

          saveAs(new Blob([this.table14CSV], { type: 'text/csv' }), this.table14FileName);
          saveAs(new Blob([this.table15CSV], { type: 'text/csv' }), this.table15FileName);
          saveAs(new Blob([this.table17CSV], { type: 'text/csv' }), this.table17FileName);
        }
        else {
          this.table22 = res.calpadsTable22Array;
          this.table23 = res.calpadsTable23Array;
          this.table24 = res.calpadsTable24Array;
          this.table25 = res.calpadsTable25Array;

          this.table22Count = res.calpadsTable22Array.length;
          this.table23Count = res.calpadsTable23Array.length;
          this.table24Count = res.calpadsTable24Array.length;
          this.table25Count = res.calpadsTable25Array.length;

          this.table22CSV = this.calpadsTablesDB.calpadsTable22CSV;
          this.table23CSV = this.calpadsTablesDB.calpadsTable23CSV;
          this.table24CSV = this.calpadsTablesDB.calpadsTable24CSV;
          this.table25CSV = this.calpadsTablesDB.calpadsTable25CSV;

          this.table22FileName = this.calpadsTablesDB.calpadsTable22FileName;
          this.table23FileName = this.calpadsTablesDB.calpadsTable23FileName;
          this.table24FileName = this.calpadsTablesDB.calpadsTable24FileName;
          this.table25FileName = this.calpadsTablesDB.calpadsTable25FileName;

          saveAs(new Blob([this.table22CSV], { type: 'text/csv' }), this.table22FileName);
          saveAs(new Blob([this.table23CSV], { type: 'text/csv' }), this.table23FileName);
          saveAs(new Blob([this.table24CSV], { type: 'text/csv' }), this.table24FileName);
          saveAs(new Blob([this.table25CSV], { type: 'text/csv' }), this.table25FileName);
        }

      this.tablesReturned = true;
      this.showSpinner = false;
    },
      err => {
        console.error(err);
        this.showSpinner = false;
      }
    );
  }

  LogIntoCALPADS() {
    this.CodeChallenge = "PT6sZPswSvzRF1pGE8ZJhEAQma1Cab0tqgdE9R71cpk";
    sessionStorage.setItem('CodeVerifier', 'V1pX0YpzRgndoqigKY98ok4AeV0qS2kD0VuxfPeCEAS2jJxrdvyRYDkx3vw7ldDskntElL9Q5XGbYfVBcBysmNsOnODUn4JO3gYsmN5vme82VJftxiuXsAYWJHGT1wB2');

    this.calpadsService.getAppsettingsData(this._baseUrl + 'api/CALPADS/GetAppsettingsData').subscribe((res: IAppsettingsConfig) => {
      window.open(res.AuthorizeUri + "?client_id=" + res.ClientId
        + "&response_type=code&scope=CALPADS.API.SpecialEducation&redirect_uri="
        + res.RedirectUri + "&code_challenge_method=S256&code_challenge=" + this.CodeChallenge, "_self");
    },
      err => {
        console.error(err);
      }
    );
  }

  ViewTable14() {
    this.priorTableState = this.showTable14;
    this.HideAllTables();
    this.showTable14 = !this.priorTableState;
  }

  ViewTable15() {
    this.priorTableState = this.showTable15;
    this.HideAllTables();
    this.showTable15 = !this.priorTableState;
  }

  ViewTable17() {
    this.priorTableState = this.showTable17;
    this.HideAllTables();
    this.showTable17 = !this.priorTableState;
  }

  HideAllTables() {
    this.showTable14 = false;
    this.showTable15 = false;
    this.showTable17 = false;
    this.showErrorsSPED = false;
    this.showErrorsSSRV = false;
    this.showUploadedFileDetails = false;
    this.showFileUploadSuccess= false;
    this.showStatusDetails = false;
  }
    

  SubmitTable(tableName) {
    this.showSpinner = true;
    var uploadFileObj = {} as ICALPADSUploadFile;
    if (tableName == 'Table14') {
      uploadFileObj.fileContent = this.table14CSV;
      uploadFileObj.fileName = this.table14FileName;
      uploadFileObj.fileType = CALPADSFileTypeEnum.SPED;
    }
    else if (tableName == 'Table15') {
      uploadFileObj.fileContent = this.table15CSV;
      uploadFileObj.fileName = this.table15FileName;
      uploadFileObj.fileType = CALPADSFileTypeEnum.SSRV;
    }
    else if (tableName == 'Table17') {
      uploadFileObj.fileContent = this.table17CSV;
      uploadFileObj.fileName = this.table17FileName;
      uploadFileObj.fileType = CALPADSFileTypeEnum.PSTS;
    }

    //UAT
    else if (tableName == 'Table22') {
      uploadFileObj.fileContent = this.table22CSV;
      uploadFileObj.fileName = this.table22FileName;
      uploadFileObj.fileType = CALPADSFileTypeEnum.SWDS;
    }
    else if (tableName == 'Table23') {
      uploadFileObj.fileContent = this.table23CSV;
      uploadFileObj.fileName = this.table23FileName;
      uploadFileObj.fileType = CALPADSFileTypeEnum.PLAN;
    }
    else if (tableName == 'Table24') {
      uploadFileObj.fileContent = this.table24CSV;
      uploadFileObj.fileName = this.table24FileName;
      uploadFileObj.fileType = CALPADSFileTypeEnum.MEET;
    }
    else if (tableName == 'Table25') {
      uploadFileObj.fileContent = this.table25CSV;
      uploadFileObj.fileName = this.table25FileName;
      uploadFileObj.fileType = CALPADSFileTypeEnum.SERV;
    }

    uploadFileObj.leaCode = '1910199';

    this.calpadsService.uploadFile(uploadFileObj).subscribe((res: ICALPADSUploadFileResponse) => {
      this.showFileUploadSuccess = true;
      this.ErrorJobId = parseInt(res.jobID);
      this.StatusJobId = parseInt(res.jobID);
      this.uploadFileResponse = res;
      this.showSpinner = false;
    },
      err => {
        console.error(err);
      }
    );
  }

  RetrieveUploadedFileList() {
    //this.showSpinner = true;
    this.HideAllTables();

    this.calpadsService.getCALPADSUploadedFiles(this._baseUrl + 'api/CALPADS/GetCALPADSUploadedFiles/' + this.DistrictCode + '^' + this.selectedUploadTimeframeOption + '^' + this.selectedFileTypeOption + '^' + this.selectedFileStatusOption + '^').subscribe((res: ICALPADSUploadedFileDetail[]) => {
      this.showUploadedFileDetails = true;
      this.uploadedFileDetails = JSON.parse(res.toString());
      //this.showSpinner = false;
    },
      err => {
        console.error(err);
        //this.showSpinner = false;
      }
    );
  }

  RetrieveErrorDetails() {

    if (this.ErrorJobId == undefined) {
      alert('Error: Please enter a Job Id first, then try again.');
      return;
    }

    //this.showSpinner = true;
    this.HideAllTables();

    if (this.selectedFileTypeOption == 'SPED') {
      this.calpadsService.getSPEDErrorDetails(this._baseUrl + 'api/CALPADS/GetSPEDErrorDetailsRequest/' + this.ErrorJobId).subscribe((res: ICALPADSErrorDetailSPED[]) => {
        this.showErrorsSPED = true;
        this.spedErrors = JSON.parse(res.toString());
        this.showSpinner = false;
      },
        err => {
          console.error(err);
          this.showSpinner = false;
        }
      );
    }
    else if (this.selectedFileTypeOption == 'SSRV') {
      this.calpadsService.getSSRVErrorDetails(this._baseUrl + 'api/CALPADS/GetSSRVErrorDetailsRequest/' + this.ErrorJobId).subscribe((res: ICALPADSErrorDetailSSRV[]) => {
        this.showErrorsSSRV = true;
        this.ssrvErrors = JSON.parse(res.toString());
        this.showSpinner = false;
      },
        err => {
          console.error(err);
          this.showSpinner = false;
        }
      );
    }
  }

  RetrieveStatusDetails() {

    if (this.StatusJobId == undefined) {
      alert('Error: Please enter a Job Id first, then try again.');
      return;
    }

    //this.showSpinner = true;
    this.HideAllTables();

    this.calpadsService.getUploadedFileStatusDetails(this._baseUrl + 'api/CALPADS/GetUploadedFileStatusDetails/' + this.StatusJobId).subscribe((res: ICALPADSStatusDetail) => {
      this.showStatusDetails = true;
      this.status = JSON.parse(res.toString());
      this.statusDetails = this.status.errorSummaryList;
      //this.showSpinner = false;
    },
      err => {
        console.error(err);
        //this.showSpinner = false;
      }
    );
  }

}
